"use client";

import { useCallback, type RefObject } from "react";

export interface UseTimelineCoordinateReadersInput {
  innerRef: RefObject<HTMLDivElement | null>;
  scrollContainerRef: RefObject<HTMLDivElement | null>;
}

export interface TimelineCoordinateReaders {
  getInnerXFromClient: (clientX: number) => number | null;
  getViewportCenterInInner: () => number | null;
}

export function useTimelineCoordinateReaders({
  innerRef,
  scrollContainerRef,
}: UseTimelineCoordinateReadersInput): TimelineCoordinateReaders {
  const getInnerXFromClient = useCallback(
    (clientX: number): number | null => {
      const innerNode = innerRef.current;
      if (!innerNode) {
        return null;
      }

      return clientX - innerNode.getBoundingClientRect().left;
    },
    [innerRef],
  );

  const getViewportCenterInInner = useCallback((): number | null => {
    const scrollContainerNode = scrollContainerRef.current;
    if (!scrollContainerNode) {
      return null;
    }

    const containerRect = scrollContainerNode.getBoundingClientRect();
    return getInnerXFromClient(
      containerRect.left + scrollContainerNode.clientWidth / 2,
    );
  }, [getInnerXFromClient, scrollContainerRef]);

  return {
    getInnerXFromClient,
    getViewportCenterInInner,
  };
}
